
    import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
    import ListBase from '@/lib/listbase';
    import Util from '@/lib/util';
    import VWidget from '@/components/VWidget.vue';
    import ApexCharts from 'apexcharts'
    import VueApexCharts from 'vue-apexcharts'

    @Component({
        components: { apexcharts: VueApexCharts, VWidget },
        watch: {
            zone: function (val) {
                (this as any).loadData();
                (this as any).options = {
                    title: {
                        text: 'Estados - ' + (this as any).zoneName
                    }
                };
            }
        }
    })

    export default class ChartOperation extends ListBase {
        @Prop({ type: Number, default: 1 }) zone: number;
        options: any = {
            chart: {
                type: 'bar',
                height: 350,
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    columnWidth: '50%',
                },
            },
            colors: ['#4CAF50', '#FF9800', '#F44336'],
            dataLabels: {
                enabled: false
            },
            stroke: {
                show: true,
                width: 2,
                colors: ['transparent']
            },
            title: { 
                text: 'Nivel de Cumplimiento - ' + this.zoneName,
                align: 'left'
            },
            fill: {
                opacity: 1
            },
            yaxis: {
                labels: {
                    formatter: function (val) {
                        return val + '%';
                    },
                },
            },
            xaxis: {
                type: 'text',
                categories: this.dealersRange
            },
        };
    
        get zoneName() {
            let zone = Util.getEntity(this, 'zone', this.zone);
            return zone.name;
        }

        get list() {
            return this.$store.state.agreement.dashLevels;
        }

        get series() {
            let levels = Util.abp.list.getList('E_LEVELS');
            let items = [];

            levels.forEach(level => {                
                items.push({ name: level.name, data: [] });
            });

            this.list.forEach(item => {
                let total = parseInt(item.level_CO) + parseInt(item.level_EN) + parseInt(item.level_NC);

                items[0].data.push((parseInt(item.level_CO) * 100 / total).toFixed(2));
                items[1].data.push((parseInt(item.level_EN) * 100 / total).toFixed(2));
                items[2].data.push((parseInt(item.level_NC) * 100 / total).toFixed(2));
            });

            return items;
        }

        get loading() {
            return this.$store.state.dashboard.loading;
        }

        get dealersRange() {
            let dealers = [];
            this.list.forEach(item => {
                dealers.push(item.dealer);
            });
            return dealers;
        }

        async loadData() {
            await this.$store.dispatch({
                type: 'agreement/getDashLevels',
                data: {
                    zone: this.zone,
                }
            });          
        }

        async mounted() { 
            await this.loadData();
            this.options = {
                xaxis: {
                    type: 'text',
                    categories: this.dealersRange
                },
            };
        }
    }
